// @flow
import { useEffect, useState } from 'react';
/*::
  import { type ElementType, type ElementRef } from 'react';

  type ReactObjRef<ElementType: ElementType> = {
    current: null | ElementRef<ElementType>
  }

  type Dimensions = {
    width: number;
    height: number;
  }
*/

/**
 * Detects the DOM height of the passed ref element
 */

export var useDimensionsDetector = function useDimensionsDetector(ref
/*: ReactObjRef<any> */
)
/*: Dimensions */
{
  var _useState = useState({
    width: 0,
    height: 0
  }),
      dimensions = _useState[0],
      setDimensions = _useState[1];

  useEffect(function () {
    var timeout = setTimeout(function () {
      var height = ref.current ? ref.current.offsetHeight : 0;
      var width = ref.current ? ref.current.offsetWidth : 0;
      setDimensions({
        height: height,
        width: width
      });
    }, 1);
    return function () {
      return clearTimeout(timeout);
    };
  }, [ref]);
  return dimensions;
};